import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-plus-icon',
  templateUrl: './plus-icon.component.html',
  styleUrls: ['./plus-icon.component.scss']
})
export class PlusIconComponent implements OnInit {

  @Input() stroke: string = 'white';
  @Input() height: string = '17';
  @Input() width: string = '16';

  constructor() { }

  ngOnInit() {
  }

}
